import { getLocale } from "../runtime";

const sv_escountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Spanien`
};

const escountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_escountry(inputs)
	return "esCountry";
};

export { escountry as "esCountry" };